import React, { useRef } from "react";
import { useAppSelector } from "@/hooks";

import AboutSection from "./AboutSection";
import GetToKnowUs from "./GetToKnowUs";
import HeroSection from "./HeroSection";
import JobOpenings from "./JobOpenings";
import OurTeam from "./OurTeam";

import { handleScrollToSection } from "@/utils";
import MainTemplate from "@/components/Templates/MainTemplate";
import { useWindowDimensions } from "@/hooks";

function CareersPage(props) {
  const { loaderHeight = "50px", loaderWidth = "360px" } = props || {};
  const jobRef = useRef(null);
  const teamRef = useRef(null);

  const careerLandingData = useAppSelector((state) => state.healthProgram);
  const careerJobData = useAppSelector((state) => state.careersPage);

  const { data, isLoading, success, error } = careerLandingData;
  const { dataCareer, successCareer, isLoadingCareer } = careerJobData;
  const { width } = useWindowDimensions() || {};

  return (
    <MainTemplate isLoading={isLoading} error={error}>
      <HeroSection
        handleScrollToSection={() =>
          handleScrollToSection({
            refElement: jobRef,
          })
        }
        data={data}
        width={width}
      />
      {data?.how_it_works?.listing.length > 0 && <AboutSection data={data} />}
      <GetToKnowUs
        data={data}
        width={width}
        handleScrollToSection={() =>
          handleScrollToSection({
            refElement: teamRef,
          })
        }
      />
      {dataCareer?.jobs?.length > 0 && (
        <JobOpenings
          jobRef={jobRef}
          landingData={data}
          data={dataCareer}
          width={width}
        />
      )}
      {data?.testimonials?.components?.length > 0 && (
        <OurTeam data={data} ref={teamRef} />
      )}
    </MainTemplate>
  );
}

export default CareersPage;
